// Cross-domain unified-view primitives (pipelines, destinations, global search).
export enum UnifiedPipelineEngine {
  STANDARD = 'STANDARD',
  EDGE = 'EDGE'
}

/** Envelope of the unified aggregation endpoints — full list in one response. */
export interface UnifiedListResponse<T> {
  data: T[];
  count: number;
  total_count: number;
  api_code: number;
}
